import AbstractAccordion from '@/modules/common/common/models/APP/accordions/AbstractAccordion'
import AccordionBullets from '@/modules/common/common/models/APP/accordions/AccordionBullets'
import AccordionChecks from '@/modules/common/common/models/APP/accordions/AccordionChecks'
import AccordionDocuments from '@/modules/common/common/models/APP/accordions/AccordionDocuments'
import AccordionLinks from '@/modules/common/common/models/APP/accordions/AccordionLinks'
import AccordionCTA from '@/modules/common/common/models/APP/accordions/AccordionCTA'
import AccordionSimple from '@/modules/common/common/models/APP/accordions/AccordionSimple'

export default class SectionFactory {
  static createAccordion(
    type: string,
    attributes: Partial<Omit<AbstractAccordion<any>, 'component'>>
  ) {
    switch (type) {
      case 'accordionBullets':
        return new AccordionBullets(attributes)
      case 'accordionChecks':
        return new AccordionChecks(attributes)
      case 'accordionDocuments':
        return new AccordionDocuments(attributes)
      case 'accordionLinks':
        return new AccordionLinks(attributes)
      case 'accordionCtas': // diferent styles
        return new AccordionCTA(attributes)
      case 'accordionSimples':
        return new AccordionSimple(attributes)

      default:
        // throw new Error(`Unknown element type: ${type}`)
        console.error(`Unknown element type: ${type}`)
        return new AccordionSimple(attributes)
    }
  }
}
